<template>
  <div
    class="groupnews_insideL"
  >
    <iframe
      id="iframe"
      :src="link"
      :height="iframeheight"
      width="100%"
      frameborder="0"
      scrolling="no"
      style="margin-top: -100px"
    />
  </div>
</template>
<script>
export default {
  data() { return {} },
  computed: {
    link() {
      return this.$route.query.link
    },
    iframeheight() {
      return this.$route.query.iframeheight
    }
  },
  mounted() {
    document.querySelector('#iframe').scrollIntoView(true)
  }
}
</script>
<style scoped>
.groupnews_insideL {
  padding-top: -100px;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/components/solutions1.vue